import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1SentryTestingTestApiErrorCreate: build.mutation<
      ApiAdminV1SentryTestingTestApiErrorCreateApiResponse,
      ApiAdminV1SentryTestingTestApiErrorCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_api_error/`,
        method: "POST",
      }),
    }),
    apiAdminV1SentryTestingTestBasicErrorCreate: build.mutation<
      ApiAdminV1SentryTestingTestBasicErrorCreateApiResponse,
      ApiAdminV1SentryTestingTestBasicErrorCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_basic_error/`,
        method: "POST",
      }),
    }),
    apiAdminV1SentryTestingTestCustomExceptionCreate: build.mutation<
      ApiAdminV1SentryTestingTestCustomExceptionCreateApiResponse,
      ApiAdminV1SentryTestingTestCustomExceptionCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_custom_exception/`,
        method: "POST",
      }),
    }),
    apiAdminV1SentryTestingTestDatabaseErrorCreate: build.mutation<
      ApiAdminV1SentryTestingTestDatabaseErrorCreateApiResponse,
      ApiAdminV1SentryTestingTestDatabaseErrorCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_database_error/`,
        method: "POST",
      }),
    }),
    apiAdminV1SentryTestingTestEnvironmentReportingCreate: build.mutation<
      ApiAdminV1SentryTestingTestEnvironmentReportingCreateApiResponse,
      ApiAdminV1SentryTestingTestEnvironmentReportingCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_environment_reporting/`,
        method: "POST",
      }),
    }),
    apiAdminV1SentryTestingTestExceptionLoggingCreate: build.mutation<
      ApiAdminV1SentryTestingTestExceptionLoggingCreateApiResponse,
      ApiAdminV1SentryTestingTestExceptionLoggingCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_exception_logging/`,
        method: "POST",
      }),
    }),
    apiAdminV1SentryTestingTestInfoRetrieve: build.query<
      ApiAdminV1SentryTestingTestInfoRetrieveApiResponse,
      ApiAdminV1SentryTestingTestInfoRetrieveApiArg
    >({
      query: () => ({ url: `/api/admin/v1/sentry-testing/test_info/` }),
    }),
    apiAdminV1SentryTestingTestTaskErrorCreate: build.mutation<
      ApiAdminV1SentryTestingTestTaskErrorCreateApiResponse,
      ApiAdminV1SentryTestingTestTaskErrorCreateApiArg
    >({
      query: () => ({
        url: `/api/admin/v1/sentry-testing/test_task_error/`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1SentryTestingTestApiErrorCreateApiResponse = unknown;
export type ApiAdminV1SentryTestingTestApiErrorCreateApiArg = void;
export type ApiAdminV1SentryTestingTestBasicErrorCreateApiResponse = unknown;
export type ApiAdminV1SentryTestingTestBasicErrorCreateApiArg = void;
export type ApiAdminV1SentryTestingTestCustomExceptionCreateApiResponse =
  unknown;
export type ApiAdminV1SentryTestingTestCustomExceptionCreateApiArg = void;
export type ApiAdminV1SentryTestingTestDatabaseErrorCreateApiResponse = unknown;
export type ApiAdminV1SentryTestingTestDatabaseErrorCreateApiArg = void;
export type ApiAdminV1SentryTestingTestEnvironmentReportingCreateApiResponse =
  unknown;
export type ApiAdminV1SentryTestingTestEnvironmentReportingCreateApiArg = void;
export type ApiAdminV1SentryTestingTestExceptionLoggingCreateApiResponse =
  unknown;
export type ApiAdminV1SentryTestingTestExceptionLoggingCreateApiArg = void;
export type ApiAdminV1SentryTestingTestInfoRetrieveApiResponse = unknown;
export type ApiAdminV1SentryTestingTestInfoRetrieveApiArg = void;
export type ApiAdminV1SentryTestingTestTaskErrorCreateApiResponse = unknown;
export type ApiAdminV1SentryTestingTestTaskErrorCreateApiArg = void;
export const {
  useApiAdminV1SentryTestingTestApiErrorCreateMutation,
  useApiAdminV1SentryTestingTestBasicErrorCreateMutation,
  useApiAdminV1SentryTestingTestCustomExceptionCreateMutation,
  useApiAdminV1SentryTestingTestDatabaseErrorCreateMutation,
  useApiAdminV1SentryTestingTestEnvironmentReportingCreateMutation,
  useApiAdminV1SentryTestingTestExceptionLoggingCreateMutation,
  useApiAdminV1SentryTestingTestInfoRetrieveQuery,
  useApiAdminV1SentryTestingTestTaskErrorCreateMutation,
} = injectedRtkApi;
